import { z } from 'zod'

// Configure before schema construction: public documents forbid eval under their CSP.
z.config({ jitless: true })
